import React, {Component} from "react";
import {
  withRouter,
  Link,
} from 'react-router-dom';
import {logToOauth} from "../tools/apitools";
import Logo from "../components/Logo";
import '../style/login.scss';
import {Context} from "../tools/context";

class Login extends Component {
  constructor() {
    super();

    this.state = {
      login: '',
      password: '',
      rememberme: false,
      errorMessage: null,
    }
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState({errorMessage: null});
    const {match, location, history} = this.props;
    logToOauth({...this.state},
      () => {
        history.replace('/Home')
      },
      (serverError) =>
        this.setState({errorMessage: serverError
            ? 'Une erreur est survenue'
            : 'Ce couple identifiant/mot de passe n\'est pas reconnu'}
        ));
    return false;
  }

  render() {
    return (
      <div>
        <div>
          <Logo/>
          <div className="formBody">
            {this.state.errorMessage ?
              <div className="error">{this.state.errorMessage}</div>
            : null}
            <form onSubmit={this.handleClick}>
              <p>
                <label htmlFor="username">Email ou Téléphone<span
                  className="required"
                >*</span></label>
                <input
                  required
                  type="text"
                  name="username"
                  id="username"
                  autoComplete="username"
                  value={this.state.login}
                  onChange={(e) => {
                    this.setState({login: e.target.value})
                  }}
                />
              </p>
              <p>
                <label htmlFor="password">Mot de passe<span
                  className="required">*</span></label>
                <input
                  required
                  name="password"
                  id="password"
                  type="password"
                  autoComplete="current-password"
                  value={this.state.password}
                  onChange={(e) => {
                    this.setState({password: e.target.value})
                  }}
                />
              </p>
              <p style={{marginTop: '40px'}}>
                {/*<label>*/}
                {/*  <input*/}
                {/*    name="rememberme"*/}
                {/*    type="checkbox"*/}
                {/*    id="rememberme"*/}
                {/*    value={this.state.rememberme}*/}
                {/*    onChange={(e) => {*/}
                {/*      this.setState({rememberme: e.target.value})*/}
                {/*    }}*/}
                {/*  />*/}
                {/*  <span>Se souvenir de moi</span>*/}
                {/*</label>*/}
                <button
                  type="submit"
                  name="login"
                  value="Identification"
                  className="button blueButton"
                >
                  Identification
                </button>
              </p>
              <p>
                <a href="https://app.bienvenus.com/mot-de-passe-oublie-old/">Mot de passe perdu ?</a>
              </p>
              <div>
                <Link to="/register" className="button whiteButton">
                  Inscription
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);